import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InspectionFormComponent } from './components/inspection-form/inspection-form.component';
import { ReportListComponent } from './components/report-list/report-list.component';

const routes: Routes = [
  { path: 'report/:pinId', component: InspectionFormComponent },
  { path: 'report/:pinId/view', component: InspectionFormComponent, data: { viewOnly: true } },
  { path: 'reports', component: ReportListComponent },
  { path: 'reports/field/:fieldId', component: ReportListComponent },
  { path: 'reports/farm/:farmId', component: ReportListComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FieldInspectionRoutingModule {}
